import { DELIVERY_TYPES } from '@/constants/delivery';
import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductQuickViewGtmEvents extends ProductGtmEvents {
  chooseColor({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_Цвет',
      eventLabel: productCode,
    });
  }

  chooseSize({ productCode, size }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_Размер',
      eventLabel: `${productCode}|${size}`,
    });
  }

  addToCart({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_ДобавитьВКорзину',
      eventLabel: productCode,
    });
  }

  redirectToCart() {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_ВКорзину',
    });
  }

  clickDetails({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_Подробнее',
      eventLabel: productCode,
    });
  }

  openSizeTable({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_ТаблицаРазмеров',
      eventLabel: productCode,
    });
  }

  changeSlide({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_ФотоСкролл',
      eventLabel: productCode,
    });
  }

  addToFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_ДобавитьВИзбранное',
      eventLabel: productCode,
    });
  }

  removeFromFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_УдалитьИзИзбранного',
      eventLabel: productCode,
    });
  }

  toggleFavorite({ value, productCode }) {
    return value
      ? this.addToFavorite({ productCode })
      : this.removeFromFavorite({ productCode });
  }

  openQuickView({ productCode, cityName }) {
    return this.gtmEvent({
      eventAction: 'Карточка_БП_Просмотр',
      eventLabel: `${productCode}|${cityName}`,
    });
  }

  chooseDelivery({ deliveryType, productCode, cityName, size, deliveryInterval, storesCount }) {
    const trackData = {
      eventAction: '',
      eventLabel: [
        productCode,
        cityName,
        size,
      ],
    };

    if (deliveryType === DELIVERY_TYPES.delivery) {
      trackData.eventLabel.push(deliveryInterval);
      trackData.eventAction = 'Карточка_БП_КликДоставитьКурьером';
    } else if (deliveryType === DELIVERY_TYPES.availability) {
      trackData.eventLabel.push(storesCount);
      trackData.eventAction = 'Карточка_БП_КликЗабратьВМагазине';
    } else if (deliveryType === DELIVERY_TYPES.postamat) {
      trackData.eventAction = 'Карточка_БП_КликДоставитьПВЗ';
    } else {
      return;
    }

    return this.gtmEvent({
      ...trackData,
      eventLabel: trackData.eventLabel.join('|'),
    });
  }

  showDelivery({ activeSku, productCode, cityName }) {
    const {
      availabilityCount,
      deliveryInterval,
      isThirdParty,
    } = this.getDeliveryInfo({ activeSku });

    const eventLabel = [
      productCode,
      cityName,
      activeSku?.size,
    ];

    if (deliveryInterval) {
      this.gtmEvent({
        eventAction: 'Карточка_БП_ПоказДоставитьКурьером',
        eventLabel: [...eventLabel, deliveryInterval].join('|'),
      });
    }

    if (availabilityCount) {
      this.gtmEvent({
        eventAction: 'Карточка_БП_ПоказЗабратьВМагазине',
        eventLabel: [...eventLabel, availabilityCount].join('|'),
      });
    }

    if (isThirdParty) {
      this.gtmEvent({
        eventAction: 'Карточка_БП_ПоказДоставитьПВЗ',
        eventLabel: eventLabel.join('|'),
      });
    }
  }
}
